import { parseAugmentRef } from './augments';

function hasFiniteNumber(value) {
  return value != null && Number.isFinite(Number(value));
}

/**
 * Whether a match-slot play successfully applied.
 * Prefer explicit `augmentApplied` / `appliedAugments`; else derive from `ap`/`ar`,
 * or legacy `aa`. Sacrifice success is attributed via Multiplier (never from dead-match points).
 *
 * @param {{
 *   augmentApplied?: boolean,
 *   appliedAugments?: string[],
 *   augmentPoints?: number,
 *   augmentRate?: number,
 *   ap?: number,
 *   ar?: number,
 *   aa?: boolean,
 *   a?: string,
 *   augment?: string,
 *   points?: number,
 *   p?: number
 * }|null|undefined} bet
 * @returns {boolean|null} true/false when known; null when the flag is absent (legacy)
 */
export function getMatchAugmentApplied(bet) {
  if (!bet) return null;
  if (bet.augmentApplied === true) return true;
  if (bet.augmentApplied === false) return false;
  if (Array.isArray(bet.appliedAugments)) {
    return bet.appliedAugments.length > 0;
  }
  if (bet.aa === true) return true;
  if (bet.aa === false) return false;

  const ref = bet.augment != null && bet.augment !== '' ? bet.augment : bet.a;
  if (ref != null && ref !== '' && parseAugmentRef(String(ref)).code === 'd') {
    return null;
  }
  // 2x bust historically stored negative ap; treat as not applied.
  const ap = hasFiniteNumber(bet.augmentPoints)
    ? Number(bet.augmentPoints)
    : hasFiniteNumber(bet.ap)
      ? Number(bet.ap)
      : null;
  if (ap != null) {
    if (ref != null && ref !== '' && parseAugmentRef(String(ref)).code === '2x' && ap < 0) {
      return false;
    }
    return true;
  }
  if (hasFiniteNumber(bet.augmentRate) || hasFiniteNumber(bet.ar)) return true;
  return null;
}

/**
 * @param {{ roundAugmentApplied?: boolean }|null|undefined} round
 * @returns {boolean|null}
 */
export function getRoundAugmentApplied(round) {
  if (!round || round.roundAugment == null || round.roundAugment === '') return null;
  if (round.roundAugmentApplied === true) return true;
  if (round.roundAugmentApplied === false) return false;
  return null;
}
